import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import appConstants from "./app.constants";


const FirebaseService = () => {

  const service = {}

  // ----------------------------------------------------------------------------------------------------------------------------------
  // Init config
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_CONFIG_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_CONFIG_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_CONFIG_MEASUREMENT_ID,
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  // Init firebase using the config
  let app;
  const initFirebase = () => {
    if (!app) app = initializeApp(firebaseConfig);
    return app;
  }
  

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Register service worker
   */
  service.registerServiceWorker = (successCB, errorCB) => {

    // if service worker not found, return error
    if (!("serviceWorker" in navigator)) {
      return errorCB && errorCB("Service workers not supported.");
    }

    // Register service worker
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js', {
        scope: '/'
      })
      .then((registration) => {
        console.log("SW registered:", registration);
        if (successCB) successCB(registration);
      })
      .catch((err) => {
        console.error(" SW registration failed:", err);
        if (errorCB) errorCB(err);
      });
  }



  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Request service token
   */
  service.requestForToken = (successCB, errorCB) => {
    
    const messaging = getMessaging(initFirebase());

    Notification.requestPermission()
      .then((permission) => {
        if (permission !== appConstants.notification.browserPermission.granted) {
          return errorCB && errorCB("Notification permission denied");
        }
        return getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        });
      })
      .then((token) => {
        if (token && successCB) successCB(token);
      })
      .catch((err) => {
        console.error("Error getting token:", err);
        if (errorCB) errorCB(err);
      });
  }


  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Listener for notification messages
   */
  service.listenForMessages = (cb) => {
    const messaging = getMessaging(initFirebase());
    onMessage(messaging, (payload) => {
      cb && cb(payload);
    });
  }


  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * 
   * @param {*} loggedIn - {boolean} - values true/false - indicating user's logged-in state
   */
  service.updateLoginState = (loggedIn) => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: "LOGIN_STATE",
        loggedIn,
      });
    }
  }
  return service
}


export default FirebaseService();
